export default __webpack_public_path__ + "static/media/ponto_6.b80a1fd0.svg";